var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpice2Juicy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#spice-2-juicy_svg__spice2-paint0_linear)",
    d: "M4 20.201V4.532h.231l9.493 3.183.054.116.115.157v15.347l-.115.165z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7864E",
    d: "M20 21.85V6.183h-.489l-5.706 1.484-.027.165V23.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#spice-2-juicy_svg__spice2-paint1_linear)",
    d: "M20 21.85V6.183h-.489l-5.706 1.484-.027.165V23.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB200",
    d: "M20 21.85V6.183h-.489l-5.706 1.484-.027.165V23.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7C632",
    d: "M10.222 2.883L4 4.533l9.778 3.298L20 6.18z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#spice-2-juicy_svg__spice2-paint2_radial)",
    d: "M10.222 2.883L4 4.533l9.778 3.298L20 6.18z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#72C188",
    d: "M8.071 10.313c.542.206 1.031.808 1.289 1.575l.169.503c-.249-.008-.382-.066-.418-.074-.044-.017-.293-.115-.684-.453a1.9 1.9 0 00-.578-.339 1.5 1.5 0 00-.809-.082 3.1 3.1 0 01-.373-1.031l-.125-.684 1.53.577z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#spice-2-juicy_svg__spice2-paint3_linear)",
    d: "M10.205 12.095c.497.165 1.128.626 1.59 1.674.703 1.591.223 3.793-.613 4.428-.355.273-.693.273-1.013.165-.418-.14-.8-.462-1.165-.585-.355-.124-.755-.058-1.164-.198-.32-.107-.649-.33-.996-.833-.808-1.196-1.208-3.686-.453-4.791.285-.413.613-.603.933-.66.24-.033.48-.017.703.066.195.066.373.165.506.264.347.255.56.33.587.346.027.017.16.05.373.058h.231c.125 0 .303.016.498.074"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1A800",
    d: "M16.791 9.208l-3.013-1.377L20 6.181l-1.875 2.615c-.303.445-.658.66-1.334.412"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#spice-2-juicy_svg__spice2-paint4_linear)",
    fillRule: "evenodd",
    d: "M9.742.64c.231-.157.622-.174.89-.091l2.497.816-.498 1.518-1.618-.553v1.75c0 .14-.426.28-.87.28-.445 0-.819-.182-.819-.28V1.49c0-.429.143-.66.427-.85",
    clipRule: "evenodd"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#spice-2-juicy_svg__spice2-paint5_linear)",
    fillRule: "evenodd",
    d: "M10.631.549l2.498.808-.498 1.517-1.911-.66c-.489-.164-1.236-.37-1.236-1.088 0-.61.72-.7 1.147-.577",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#930425",
    d: "M13.353 2.257c.14-.417.04-.817-.222-.893-.263-.075-.59.202-.729.62-.14.417-.04.817.222.892s.589-.201.729-.619"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "spice-2-juicy_svg__spice2-paint0_linear",
    x1: 12.027,
    x2: 6.879,
    y1: 5.547,
    y2: 21.814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE43F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAC23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "spice-2-juicy_svg__spice2-paint1_linear",
    x1: 13.778,
    x2: 15.058,
    y1: 14.841,
    y2: 14.841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#57D590"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#7BE393",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "spice-2-juicy_svg__spice2-paint3_linear",
    x1: 5.973,
    x2: 12.133,
    y1: 14.857,
    y2: 14.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#B3203B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EC0A89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "spice-2-juicy_svg__spice2-paint4_linear",
    x1: 9.316,
    x2: 11.022,
    y1: 2.429,
    y2: 2.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#BC373E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E43648"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "spice-2-juicy_svg__spice2-paint5_linear",
    x1: 11.52,
    x2: 10.984,
    y1: 0.722,
    y2: 2.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC4B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#DB2C4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#C12046"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#BD2B43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C72048",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spice-2-juicy_svg__spice2-paint2_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-.16612 1.05262 3.71153 .50418 5.943 5.788)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC9D02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAB54",
    stopOpacity: 0
  })))));
}
export default "data:image/svg+xml;base64,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";
export { SvgSpice2Juicy as ReactComponent };